// extracted by mini-css-extract-plugin
module.exports = {"durationInformation":"DurationInformation_durationInformation__3fBkA","h4":"DurationInformation_h4__35Hry","infoItem":"DurationInformation_infoItem__1pR77"};